export default __webpack_public_path__ + "static/media/microsoft-teams.ee06e713.svg";